import { CalendarDayInterface } from '../../utils';
import { CurrencyCode } from '../vehicle';

export enum CapitalActionNoticeStatus {
  Draft = 'draft',
  Published = 'published',
}

export type CapitalActionNoticeData = {
  id: string;
  vehicleId: string;
  capitalActionId: string;
  vehicleName: string;
  investorName: string;
  noticeDate: CalendarDayInterface;
  noticeNarrative: string;
  capitalDueDate: CalendarDayInterface;
  mainContactEmails: string;
};

export type CapitalActionNoticeCommitmentData = {
  totalCommitmentLcy: number;
  overallFundSize: number;
  percentageOfTotalFundSize: number;
  percentageOfFundAssets: number | null;
};

export type CapitalActionNoticeUnfundedCommitmentBalance = {
  beforeNotice: {
    unfundedCommitmentLcy: number;
    paidInCapitalLcy: number;
    recallableDistributionsLcy: number;
  };
  inTheNotice: {
    capitalCalledLcy: number;
    recallableDistributionLcy: number;
    equalisationInterestCalledLcy: number;
  };
  newUnfundedCommitmentLcy: number;
};

export type CapitalActionNoticeTransactionBreakdownData = {
  capitalCalls: Array<{
    label: string;
    value: number;
    subLabel?: string;
  }>;
  capitalDistributions: Array<{
    label: string;
    value: number;
    subLabel?: string;
  }>;
};

export type CapitalActionNoticeCumulativeCapitalPosition = {
  commitmentPosition: {
    contributionsAmountLcy: number;
    distributionsAmountLcy: number;
    nonRecallableDistributionsAmountLcy: number;
    otherPaymentsAmountCalledLcy: number;
    otherPaymentsAmountDistributedLcy: number;
  };
  fundPosition: {
    contributionsAmountLcy: number;
    distributionsAmountLcy: number;
  };
};

export type CapitalActionNoticeCumulativeCapitalPositionData = {
  beforeNotice: CapitalActionNoticeCumulativeCapitalPosition;
  afterNotice: CapitalActionNoticeCumulativeCapitalPosition;
  inTheNotice: CapitalActionNoticeCumulativeCapitalPosition;
};

export type PaymentDetails = {
  payee: {
    beneficiaryName: string;
    bankName: string;
    paymentReference: string;
    bankAccountNumber?: string;
    iban?: string;
    swift?: string;
    sortCode?: string;
    additionalBankCode?: string;
    bankAddress: string;
    paymentInstructions?: string;
    currency: CurrencyCode;
  };
  payer: {
    investorAccountNumber: string;
  };
};

export type CapitalActionNoticeProps = {
  firmName: string;
  firmLogoUrl?: string;
  firmContactEmail: string;
  firmWhiteBackgroundLogoUrl?: string;
  firmDomain: string;
  currencyLcy: CurrencyCode;
  paymentRequired: boolean;
  totalNetCapitalCalledLcy: number;
  palette: {
    firmBackgroundColor: string;
    backgroundContrastColor: string;
    backgroundSubtleContrastColor: string;
    firmSecondaryColor: string;
  };
  paymentDetails: PaymentDetails;
  capitalActionNotice: CapitalActionNoticeData;
  commitment: CapitalActionNoticeCommitmentData;
  unfundedCommitmentBalance: CapitalActionNoticeUnfundedCommitmentBalance;
  transactionBreakdown: CapitalActionNoticeTransactionBreakdownData;
  cumulativeCapitalPosition: CapitalActionNoticeCumulativeCapitalPositionData;
};
